import { assoc } from 'ramda';
import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { useOrder } from '#views/Dashboard/hooks';
import { EditInput } from '../../../Service/components/PickupDelivery/components';
import {
  CustomerContainer, Span, Text, Title, useCustomerInfoStyles,
} from './style';

const CustomerInfo = () => {
  const { id } = useParams();
  const {
    order: {
      data: { customer },
    },
    handlers,
  } = useOrder();
  const classes = useCustomerInfoStyles();

  const properOnChange = field => async (fieldData) => {
    const updatedCustomer = assoc(field, fieldData, customer);
    await handlers.update(id, { values: { customer: updatedCustomer }, enableSnackbar: true });
  };

  return (
    <div className={classes.root}>
      <Title>Customer</Title>
      <CustomerContainer>
        <Text>
          <Span>Name</Span>
          {customer.name}
        </Text>
        <Text>
          <Span>Surname</Span>
          {customer.surname}
        </Text>
        <Text>
          <Span>Phone</Span>
          <EditInput value={customer.phone} onChange={properOnChange('phone')}>
            {customer.phone}
          </EditInput>
        </Text>
        <Text>
          <Span>Email</Span>
          <EditInput value={customer.email} onChange={properOnChange('email')}>
            {customer.email}
          </EditInput>
        </Text>
      </CustomerContainer>
    </div>
  );
};
export default CustomerInfo;
